import { NgModule, ErrorHandler } from '@angular/core';
import { IonicModule, IonicErrorHandler } from 'ionic-angular';
import { PageRef } from '../../core/core.module';

import { HomePage } from './pages/home/home';
import { HomePageFull } from './pages/home/home.full';
import { HomeCommon } from './pages/home/home.common';
import { DynamicHTMLModule } from '../dynamic-html/dynamic-html.module';

import { HomeData }from'./providers/home-data';
//Export
export { HomePage } from './pages/home/home';
export { HomePageFull } from './pages/home/home.full';

@NgModule({
    imports: [
        IonicModule,
        DynamicHTMLModule
    ],
    declarations: [
        HomePage,
        HomePageFull
    ],
    exports: [
        HomePage,
        HomePageFull
    ],
    bootstrap: [],
    entryComponents: [
        HomePage,
        HomePageFull
    ],
    providers: [{provide: ErrorHandler, useClass: IonicErrorHandler}, HomeData, HomeCommon]
})
export class HomeModule{
    constructor(public pageRef: PageRef){
       this.pageRef.addCfgLinks([
            { component: HomePage, fullComponent: HomePageFull,  name: 'HomePage', segment: 'home' }
        ]) 
    }
}


// WEBPACK FOOTER //
// ./src/modules/home/home.module.ts